module.exports = __webpack_public_path__ + "static/img/cont34 (10).5a217e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont34 (10).jpg
// module id = +5QB
// module chunks = 0